import { IEnvironment } from "./environment.interface";

export const environment: IEnvironment = {
  region: "us-east-2",
  userPoolId: "us-east-2_MfAAGjOdj",
  userPoolWebClientId: "6soq4get8fmumj6nhsn6tjb2r1",
  identityPoolId: "us-east-2:9e264ca3-fb22-4351-b7de-a44cdb17fd40",
  bucket: "netgreen-assets-staging-dev",
};
